import getDocument from './getDocument';
const setRootStyleProperty = (variable, value) => {
  const currentValue = getDocument().documentElement.style.getPropertyValue(variable);
  if (currentValue === value) {
    return;
  }
  getDocument().documentElement.style.setProperty(variable, value);
};
export default setRootStyleProperty;